<h1 mat-dialog-title>{{ dialogTitle }}</h1>
<mat-dialog-content>
    <mat-form-field>
        <mat-label>Client name</mat-label>
        <input
            matInput
            [(ngModel)]="newClientName"
            [disabled]="crud === 4"
            required
            (ngModelChange)="crud === 3 ? checkValidChanges() : checkIsValid()" />
    </mat-form-field>
</mat-dialog-content>
<mat-dialog-actions align="end">
    <button mat-stroked-button color="primary" mat-dialog-close (click)="cancelDialog()">
        <span>Cancel</span>
    </button>
    <button
        mat-flat-button
        [color]="crud !== 4 ? 'primary' : 'warn'"
        (click)="crud === 4 ? archiveClient() : saveClient()"
        [disabled]="crud === 3 ? !isValid || !hasChanges : !isValid">
        <span *ngIf="crud === 1">Create</span>
        <span *ngIf="crud === 3">Save</span>
        <span *ngIf="crud === 4">Archive</span>
    </button>
</mat-dialog-actions>
